import {Component, EventEmitter, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import {ServersApiService} from '../../../services/api/users/servers/servers-api.service';
import {MatTabChangeEvent} from '@angular/material/tabs';
import * as _ from 'lodash';
import {
  LdapServerCertificateViewComponent
} from '../ldap-server-certificate-view/ldap-server-certificate-view.component';

export interface ServersDialogInf {
  selectedItem: any;
  isEditMode?: boolean;
  normalizationGroupsOptions: Array<any>;
  attributes: Array<any>;
  type?: string;
}

@Component({
  selector: 'servers-dialog',
  templateUrl: './servers-dialog.component.html',
  styleUrls: ['./servers-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServersDialogComponent implements OnInit {

  connectivity: any;
  isTestConnectivityReady: boolean;
  adAttributes = [];
  invalidQueryMsg: string;

  constructor(public dialogRef: MatDialogRef<ServersDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ServersDialogInf,
              private formBuilder: FormBuilder,
              private serversApiService: ServersApiService,
              private dialog: MatDialog) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  settingsTabName: string;
  propertiesTabName: string;
  updatesTabName: string;
  mapForm: any;
/*  myControl = new FormControl();
  filteredADAttributes: Observable<any[]>;*/

  ngOnInit(): void {
    if (!this.data.isEditMode) {
      this.data.selectedItem.type = this.data.type;
      this.data.selectedItem.searchFilter = this.data.type === 'AZURE' ? '' : this.data.selectedItem.searchFilter;
    }

    this.settingsTabName = `${(this.data.selectedItem.type === 'LDAP') ? 'LDAP' : (this.data.selectedItem.type === 'AZURE') ? 'Azure AD' : 'UMP'} General Settings`;
    this.propertiesTabName = `${(this.data.selectedItem.type === 'LDAP') ? 'LDAP' : (this.data.selectedItem.type === 'AZURE') ? 'Azure AD' : 'UMP'} Mapping`;
    this.updatesTabName = `${(this.data.selectedItem.type === 'LDAP') ? 'LDAP' : (this.data.selectedItem.type === 'AZURE') ? 'Azure AD' : 'UMP'} Scheduling Settings`;

    if (!this.data.isEditMode) {
      this.initializeAttributeMappingsForAdd();
      if (this.data.selectedItem.type !== 'LDAP'){
        this.data.selectedItem.pageSize = 999;
      }
    } else {
      this.initializeAttributeMappingsForEdit();
    }
    this.invalidQueryMsg = '';
  }

  cancel(): any {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): any {
    this.dialogRef.close();
    this.onApply.emit(this.data.selectedItem);
  }

  testConnectivity(): void {
    this.isTestConnectivityReady = false;
    this.serversApiService.testServer(this.data.selectedItem).then(testConnectivityResult => {
      if (testConnectivityResult.availableAttributes) {
        this.adAttributes = testConnectivityResult.availableAttributes.map((adAttr) => {
          return {text: adAttr, value: adAttr};
        });

        this.addMissingAdAttrNames(testConnectivityResult.availableAttributes);
      }else {
        this.adAttributes = [];
      }
      this.connectivity = testConnectivityResult;
      this.isTestConnectivityReady = true;
      this.validateQuery();
    });
  }

  onTabChanged($event: MatTabChangeEvent): void {
    if ($event.index === 1 && !this.connectivity && !this.isTestConnectivityReady){
      this.testConnectivity();
    }
  }

  private addMissingAdAttrNames(availableAttributes: any): void {
    if (!!this.data.selectedItem.dicAttrMapping && this.data.selectedItem.dicAttrMapping.length > 0) {
      this.data.selectedItem.dicAttrMapping.forEach(mapping => {
        if (!!mapping.aDAttrName && availableAttributes.indexOf(mapping.aDAttrName) === -1) {
          this.adAttributes.push({text: mapping.aDAttrName, value: mapping.aDAttrName});
        }
      });
    }
  }

  initializeAttributeMappingsForAdd(): void {

    const notMappedAttrs = this.data.attributes
      .filter((attribute) => {
        return !attribute.isCombined;
      })
      .map((attribute) => {
        return {
          dicAttrId: attribute.id,
          dicAttrName: attribute.name,
          aDAttrName: this.getDefaultRemoteName(attribute),
          normalizationGroupId: null
        };
      });

    this.data.selectedItem.dicAttrMapping.push.apply(this.data.selectedItem.dicAttrMapping, notMappedAttrs);
  }

   getDefaultRemoteName(attribute: any): string {

    if (_.isNil(attribute.defaultRemoteName)) {
      return null;
    }

    switch (this.data.type) {
      case 'AZURE':
        if (attribute.defaultRemoteName === 'msRTCSIP-Line') {
          return null;
        }
        if (attribute.defaultRemoteName === 'co') {
          return 'country';
        }
        if (attribute.defaultRemoteName === 'tenantId') {
          return null;
        }
        break;
      case 'UMP':
        if (attribute.defaultRemoteName === 'displayName') {
          return 'DisplayName';
        }
        if (attribute.defaultRemoteName === 'department') {
          return 'Department';
        }
        if (attribute.defaultRemoteName === 'msRTCSIP-Line') {
          return 'LineURI';
        }
        if (attribute.defaultRemoteName === 'co') {
          return null;
        }
        if (attribute.defaultRemoteName === 'telephoneNumber') {
          return null;
        }
        if (attribute.defaultRemoteName === 'memberOf') {
          return null;
        }
        if (attribute.defaultRemoteName === 'tenantId') {
          return 'TenantId';
        }
        break;
      case 'Azure AD':
        if (attribute.defaultRemoteName === 'tenantId') {
          return null;
        }
        break;
    }

    return attribute.defaultRemoteName;
  }

  initializeAttributeMappingsForEdit(): void {
    const notMappedAttrs = this.data.attributes
      .filter((attribute) => {
        return !attribute.isCombined && !this.data.selectedItem.dicAttrMapping.find((mapping) => {
          return mapping.dicAttrId === attribute.id;
        });
      })
      .map((attribute) => {
        return {
          dicAttrId: attribute.id,
          dicAttrName: attribute.name,
          aDAttrName: null,
          normalizationGroupId: null
        };
      });
    this.data.selectedItem.dicAttrMapping.push.apply(this.data.selectedItem.dicAttrMapping, notMappedAttrs);
  }

  onFileChange(file: any): void {
    if (file && file.length === 1) {
      const fileReader: FileReader = new FileReader();
      fileReader.onloadend = (content: any) => {
        this.data.selectedItem.certificate = content.target.result;
      };
      fileReader.onerror = (event) => {
        this.data.selectedItem.certificate = '';
      };
      fileReader.readAsText(file[0]);
    }
  }

  openCertificateView(): void {
    this.dialog.open(LdapServerCertificateViewComponent, {data: this.data.selectedItem, width: '650px', height: '610px'});
  }

  validateQuery(): void {
    // validate advanced query + memberOf(causing expand) together
    const hasMemberOfMapping = this.data.selectedItem.dicAttrMapping.some(mapping => mapping.aDAttrName === 'memberOf');
    if (this.connectivity && this.connectivity.availableAttributes && hasMemberOfMapping && this.data.selectedItem.advancedSearchFilter) {
      if (!this.data.selectedItem.fullGroupMembership) {
        this.invalidQueryMsg = 'The \'Fetch all groups and all their members\' option must be enabled in order to use the \'memberOf\' mapping with advanced query capabilities\'.';
      } else {
        this.invalidQueryMsg = '';
      }
    } else {
      this.invalidQueryMsg = '';
    }
  }
}
